import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    becomingAwareThrough: string,
    period: string,
    entranceDate: string,
    hourlyWage: string,
    stage: string,
    lawSector: string,
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    becomingAwareThrough: string = "";
    period: string = "";
    entranceDate: string = "";
    hourlyWage: string = "";
    stage: string = "";
    lawSector: string = "";
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "becomingAwareThrough", value: this.becomingAwareThrough },
            { name: "period", value: this.period },
            { name: "entranceDate", value: this.entranceDate },
            { name: "hourlyWage", value: this.hourlyWage },
            { name: "stage", value: this.stage },
            { name: "lawSector", value: this.lawSector },
        );

        return application;
    }
}
